import { render, staticRenderFns } from "./ApfUploadInput.vue?vue&type=template&id=535778cd"
import script from "./ApfUploadInput.vue?vue&type=script&lang=js"
export * from "./ApfUploadInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports